import React from "react";
import LoadingIcon from "./LoadingIcon";
import styled from "styled-components";

const LoadingScreen = (props) => {
  if (props.loadingState) {
    return (
      <LoadingDiv>
        <Loading>
          <LoadingIcon loadingState={true} />
        </Loading>
      </LoadingDiv>
    );
  } else {
    return null;
  }
};

export default LoadingScreen;

const LoadingDiv = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  text-align: center;
  background: rgb(0 0 0 / 53%);
  z-index: 99999;
`;

const Loading = styled.div`
  position: absolute;
  top: 50%;
  left: calc(50% - 36px);
`;
